import {
  EntityList,
  EntityListProps,
  renderDate,
  renderEnum,
  renderPersona,
  renderStatusIcon,
} from 'components/EntityList'
import { Proving, User } from 'gql.generated'
import { Box } from 'grid'
import {
  ConstrainMode,
  PersonaSize,
  SelectionMode,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

type ReadProvings_workers = any

export type ArchiveCreatorListProps = EntityListProps<ReadProvings_workers>

export const ArchiveCreatorList: React.FunctionComponent<
  ArchiveCreatorListProps
> = ({ items, ...props }) => {
  const { t } = useTranslation()

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = React.useMemo(
    () => [
      fieldColumn('status', {
        onRender: renderStatusIcon,
        ungroupable: true,
      }),
      fieldColumn('id', { ungroupable: true }),
      fieldColumn('dateFrom', {
        onRender: renderDate,

        ungroupable: true,
      }),
      fieldColumn('dateTo', {
        onRender: renderDate,
        ungroupable: true,
      }),

      fieldColumn('title', {
        ungroupable: true,
        minWidth: 320,
      }),
      fieldColumn('provingGround.title', {
        onRender: (item, i, col) => {
          return `${
            item.provingGround && item.provingGround.title
              ? item.provingGround.title
              : ''
          }, ${
            item.provingGround && item.provingGround.countryCode
              ? item.provingGround.countryCode
              : ''
          }`
        },
        ungroupable: true,
        getGroupValue: (item: Proving) =>
          `${
            item.provingGround && item.provingGround.title
              ? item.provingGround.title
              : ''
          }, ${
            item.provingGround && item.provingGround.countryCode
              ? item.provingGround.countryCode
              : ''
          }`,
      }),
      fieldColumn('responsible', {
        onRender: (item, i, col) => {
          return (
            <div key={i}>
              {item.responsible.map((user: User, a: any) => {
                return (
                  <Box key={a} style={{ whiteSpace: 'pre-line' }}>
                    {user.name}
                  </Box>
                )
              })}
            </div>
          )
        },
        ungroupable: true,
        minWidth: 105,
      }),
      fieldColumn('createdBy', {
        onRender: renderPersona({
          size: PersonaSize.size8,
        }),
        getGroupValue: (item: Proving) => {
          let result = ''
          if (item.createdBy) {
            result = `${result} ${item.createdBy.name}`
          }
          return result
        },
        ungroupable: true,
        minWidth: 105,
        isGrouped: true,
      }),
      fieldColumn('department', { ungroupable: true }),
      fieldColumn('status', {
        onRender: renderEnum(t, 'status'),
        getGroupValue: (item: Proving) => t(`enum.status.${item.status}`),
        minWidth: 40,
        maxWidth: 60,
        ungroupable: true,
      }),
    ],
    [fieldColumn, t]
  )

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.multiple}
      items={items}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={columns}
      {...props}
    />
  )
}
